<template>
  <div class="or-content" @click.stop>
    <div class="close iconfont icon-cha" @click="bindClose"></div>
    <div class="title">去点外卖</div>
    <div class="b-list">
      <div
        class="b-item"
        @click="bindClick(item)"
        v-for="(item, index) in btnList"
        :key="index"
        v-buried
        :data-buried="buriedData[index].buried"
        v-clickBuried
        :data-click-buried="buriedData[index].clickBuried"
      >
        <img class="b-image" :src="item.image" alt="" />
        <div class="b-text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    buriedData: {
      type: Array,
      default: () => {
        return [
          {
            buried: 'BG_JTCSM_WM_MT',
            clickBuried: 'CLICK_JTCSM_WM_MT'
          },
          {
            buried: 'BG_JTCSM_WM_ELM',
            clickBuried: 'CLICK_JTCSM_WM_ELM'
          }
        ]
      }
    }
  },
  data() {
    return {
      btnList: [
        {
          id: 1,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f2ce9cd2484a4c64739a66413bd7c543.png',
          text: '美团外卖',
          toast: '美团外卖频道',
          launchUrlApp:
            'imeituan://www.meituan.com/search/result?entrance=0&q=',
          appSearch: true, //是否可以输入搜索关键字
          username: 'gh_870576f3c6f9',
          path: 'waimai/packages/index/search/search.html?entranceId=0&cateType=0&subCateType=0&keyword=',
          minSearch: true
        },
        {
          id: 2,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ccea77a647e721d2f35984b2d5a311c7.png',
          text: '饿了么',
          toast: '饿了么',
          launchUrlApp: 'eleme://',
          appSearch: true, //是否可以输入搜索关键字
          username: 'gh_6506303a12bb',
          path: 'ele-search/pages/search-result/search-result.html?keyword=',
          minSearch: true
        }
      ]
    }
  },
  methods: {
    bindClick(item) {
      this.$emit('close', item)
    },
    bindClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.or-content {
  animation: mymove 0.3s ease;
  box-sizing: border-box;
  background-color: #fff;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 3333;
  padding: 17px 20px 37px;

  .close {
    width: 15px;
    height: 15px;
    padding: 10px;
    right: 0px;
    top: 0px;
    position: absolute;
    color: #000;
    font-size: 16px;
  }

  .title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    margin-bottom: 19px;
  }

  .b-list {
    display: flex;
    align-items: center;
    justify-content: center;

    .b-item {
      margin-right: 80px;

      .b-image {
        width: 60px;
        height: 60px;
        object-fit: contain;
        margin-bottom: 6px;
      }

      .b-text {
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.7);
        line-height: 17px;
      }
    }

    .b-item:last-child {
      margin-right: 0;
    }
  }
}

@keyframes mymove {
  0% {
    transform: translateY(100%);
  }

  100% {
    transform: translateY(0%);
  }
}
</style>
